import { utils, writeFile, read } from 'xlsx'
import React, {useState, useRef, useEffect, Fragment} from 'react';
import { removeEmptyProperties, errorAlert } from './utils';


/**
 * #excelExportImport
 * Export an excel file with the given data and sheet title.
 * @param {Array} data - the data to be exported
 * @param {string} sheetTitle - the title of the sheet
 */
export const exportExcel = (data, sheetTitle) => {
    console.log("EXPORT EXCEL")
    let wb = utils.book_new(),
    ws = utils.json_to_sheet(data);
    utils.book_append_sheet(wb, ws, sheetTitle)
    writeFile(wb, `${sheetTitle}.xlsx`)
  }


/**
 * #excelExportImport
 * @param {*} data an array of objects, key is the header property is the value
 * @param {*} title type string, title of the sheet
 * @returns an object {data, title}
 */
export const sheet = (data, title) => {
  const doc = {data, title}
return doc
}

  /**
 * #excelExportImport
 * @param {*} param0 
 * title: the workbook title,
 * sheets: array of objects sheet()
 * @returns exports an excel
 */
export const ExportExcelButton = ({title, sheets, customFn}) =>{

  const exportExcelFile = async() => {
  console.log("EXPORT EXCEL")
  let wb = utils.book_new();

  for(const sheet of sheets){
      const ws = utils.json_to_sheet(sheet?.data);
      utils.book_append_sheet(wb, ws, sheet?.title)
      customFn && customFn(sheet)
/*         if(sheet?.title=="PRODOTTI"){
          utils.sheet_set_array_formula(sheet, "F2:F", "F2:F*B2:B")
      } */
  }
  
  writeFile(wb, `${title}.xlsx`)
  }
  return(
  <button style={{marginBottom:"10px", backgroundColor:"green"}}className='pdf-button' onClick={()=>exportExcelFile()}>
      ESPORTA EXCEL
  </button>   
  )
}

  /**
 * #excelExportImport
 * @param {*} param0 
 * title: the workbook title,
 * sheets: array of objects sheet()
 * @returns exports an excel
 */
  export const ImportExcelButton = ({returnedData =()=>{}, sheetName = ""}) =>{
    const hiddenFileInput = useRef(undefined);
    const handleClick = event => {
      hiddenFileInput.current.click();
    };
    const uploadFile = async (e) => {
      {
        const file = e.target.files[0];
        const data = await file.arrayBuffer();
        /* data is an ArrayBuffer */
        const wb = read(data);
      
        /* DO SOMETHING WITH workbook HERE */
        const firstSheet = wb && wb.Sheets[wb?.SheetNames[0]]
        const foundSheet = wb && wb.Sheets[!Array.isArray(wb?.SheetNames) ? undefined : wb?.SheetNames?.find?.((x)=>x == sheetName)]
        const jsonData = utils.sheet_to_json(foundSheet ? foundSheet : firstSheet)
        returnedData(jsonData)
      }
    }
    return(
      
      <div>
        <button style={{marginBottom:"10px", backgroundColor:"blue"}}className='pdf-button' onClick={handleClick}>
          IMPORTA EXCEL
        </button> 
      <input
        type="file"
        name="upload-file"
        ref={hiddenFileInput}
        style={{display:"none"}}
        onChange={(e)=>uploadFile(e)}
        className="insert-photo-button"
      />
    </div>  
    )
  }

/**
 * #excelExportImport
 * Check if the data is correct according to the schema
 * @param {Object} dataCheckDoc - An object containing type, excelData and schema
 * @returns {boolean} True if the data is correct, false otherwise
 */
export const dataCheck = (dataCheckDoc) => {
       
  const{type, excelData, schema} = dataCheckDoc
  console.log("CHECK SCHEMA", type, schema, excelData)
  //CHECK _TYPE
  const areAllDocsTheSameType = excelData?.every?.((x)=>x?._type == type)
  if (!areAllDocsTheSameType) {
      errorAlert(`I DOCUMENTI NON SONO TUTTI DELLO STESSO TIPO ${type}`);
      console.log(`I DOCUMENTI NON SONO TUTTI DELLO STESSO TIPO ${type}`)
      return false
  }
  //Check Data
  for (const item of excelData) {
      const obj = removeEmptyProperties(item)
      for(const key in obj) {
          const value = obj[key]
          //console.log("item properties",`${key}: ${value}`)
          if(key == "_key" || key == "_id" || key == "_type") continue
          const findInSchema = !Array.isArray(schema?.fields) ? undefined : schema?.fields?.find?.((x=>x?.name == key))
          if(!findInSchema) {
              errorAlert(`PROPRIETA' NON TROVATA NELLO SCHEMA ${key}`)
              console.log(`PROPRIETA' NON TROVATA NELLO SCHEMA ${key}`)
              return false
          }

          const valueType = value?._type ? value?._type : typeof value

          if(value?._type == "reference" && !value?._ref ) {
              errorAlert(`manca id in reference`)
              console.log(`manca id in reference`, `${key}: ${value}`, obj)
              return false
          }
          if(findInSchema?.type == "email" && typeof value == "string") {
            return true
        }
         // console.log("item value types",valueType)
          //if(!valueType) continue
          if(valueType !== findInSchema?.type) {
              errorAlert(`Tipologia dato diversa dallo schema. Trovato ${valueType} invece di ${findInSchema?.type}`)
              console.log(`Tipologia dato diversa dallo schema. Trovato ${valueType} invece di ${findInSchema?.type}`, `${key}: ${value}`, obj)
              return false
          }
      }
  }

  return true
}

  /* 




*/